/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gateway_Sub_Cancel_TitleInputs */



/**
* | output |
* | --- |
* | "Cancel subscription" |
*
* @param {Gateway_Sub_Cancel_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const gateway_sub_cancel_title = /** @type {((inputs?: Gateway_Sub_Cancel_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gateway_Sub_Cancel_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Abonnement kündigen")
	return /** @type {LocalizedString} */ ("Cancel subscription")
});